/**
 * Normalise an email address for use as a cognito username.
 *
 * Our Cognito pool is case-sensitive, but we always force lowercase.
 */
export const normaliseUsername = (email: string): string => email.toLowerCase();
